//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import forgotPasswordApi from "@/services/api-dtime/api_forgot_password.js";

const COMMON_PASSWORDS = [
  "12345678",
  "123456789",
  "1234567890",
  "password",
  "password1",
  "password123",
  "11111111",
  "00000000",
  "qwertyui",
  "qwerty123",
  "abc12345",
  "letmein1",
  "iloveyou",
  "admin123",
  "welcome1",
  "changeme",
];

export default {
  name: "ForgotPasswordFlow",
  mounted() {
    // if (api.isLoggedIn()) {
    //   this.$router.push("/dashboard");
    // }

    this.$hideLoader();
  },
  data() {
    return {
      step: 1,
      loading: false,
      errorMessage: "",

      // step 1
      companyCode: "",
      phoneCountry: "+66",
      phone: "",

      // step 2
      sessionId: "",
      phoneMasked: "",
      otpCode: "",
      otpState: "input", // input | expired | locked
      attemptsRemaining: null,
      countdown: 300, // 5 นาที
      countdownTimer: null,
      resendCountdown: 45,
      resendTimer: null,

      // step 3
      resetToken: "",
      newPassword: "",
      confirmPassword: "",
      showPassword1: false,
      showPassword2: false,
    };
  },
  computed: {
    headerTitle() {
      if (this.step === 1) return "Forgot your password?";
      if (this.step === 2) return "Verify your identity";
      if (this.step === 3) return "Create a new password";
      return "";
    },
    headerDesc() {
      if (this.step === 1)
        return "Enter your company code and your registered phone number to reset your password.";
      if (this.step === 2) return `Enter the 6-digit code we sent to`;
      if (this.step === 3)
        return "Your new password must be different from your previous passwords.";
      return "";
    },
    countdownDisplay() {
      const m = Math.floor(this.countdown / 60)
        .toString()
        .padStart(2, "0");
      const s = (this.countdown % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    },
    rule() {
      return {
        len: this.newPassword.length >= 8,
        hasNumber: /\d/.test(this.newPassword || ""),
        notCommon: !COMMON_PASSWORDS.includes(
          (this.newPassword || "").toLowerCase(),
        ),
        match:
          this.newPassword.length > 0 &&
          this.newPassword === this.confirmPassword,
      };
    },
    canSubmitPassword() {
      return (
        this.rule.len &&
        this.rule.hasNumber &&
        this.rule.notCommon &&
        this.rule.match
      );
    },
    strengthScore() {
      const p = this.newPassword || "";
      let score = 0;
      if (p.length >= 8) score++;
      if (p.length >= 12) score++;
      if (/[a-z]/.test(p) && /[A-Z]/.test(p)) score++;
      if (/\d/.test(p)) score++;
      if (/[^A-Za-z0-9]/.test(p)) score++;
      return score; // 0-5
    },
    strengthPercent() {
      if (!this.newPassword) return 0;
      return Math.min(100, (this.strengthScore / 5) * 100);
    },
    strengthLabel() {
      if (this.strengthScore <= 2) return "Weak";
      if (this.strengthScore <= 3) return "Fair";
      return "Strong";
    },
    strengthColor() {
      if (this.strengthScore <= 2) return "#d32f2f";
      if (this.strengthScore <= 3) return "#f9a825";
      return "#2e7d32";
    },
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    clearTimers() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      if (this.resendTimer) clearInterval(this.resendTimer);
    },
    startOtpTimers() {
      this.clearTimers();
      this.countdown = 300;
      this.resendCountdown = 45;
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.otpState = "expired";
        }
      }, 1000);
      this.resendTimer = setInterval(() => {
        if (this.resendCountdown > 0) this.resendCountdown--;
        else clearInterval(this.resendTimer);
      }, 1000);
    },

    // ==================== STEP 1 ====================
    async onSendOtp() {
      this.errorMessage = "";
      if (!this.companyCode.trim()) {
        this.errorMessage = "Please input Company Code";
        return;
      }
      if (!this.phone.trim()) {
        this.errorMessage = "Please input Phone Number";
        return;
      }

      this.loading = true;
      try {
        const res = await forgotPasswordApi.requestOtp(
          this.companyCode.trim(),
          this.phone.trim(),
        );
        this.loading = false;

        if (res.data && res.data.success) {
          this.sessionId = res.data.session_id;
          this.phoneMasked = res.data.phone_masked || this.phone;
          this.otpCode = "";
          this.otpState = "input";
          this.attemptsRemaining = null;
          this.step = 2;
          this.startOtpTimers();
        } else {
          this.errorMessage =
            (res.data && res.data.message) || "ส่ง OTP ไม่สำเร็จ";
        }
      } catch (error) {
        this.loading = false;
        this.errorMessage = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
      }
    },

    // ==================== STEP 2 ====================
    onOtpFinish(code) {
      this.otpCode = code;
    },
    async onVerifyOtp() {
      this.errorMessage = "";
      this.loading = true;
      try {
        const res = await forgotPasswordApi.verifyOtp(
          this.sessionId,
          this.otpCode,
        );
        this.loading = false;
        const data = res.data;

        if (data && data.success) {
          this.clearTimers();
          this.resetToken = data.reset_token;
          this.newPassword = "";
          this.confirmPassword = "";
          this.step = 3;
          return;
        }

        if (data && data.code === "OTP_EXPIRED") {
          this.otpState = "expired";
          this.clearTimers();
          return;
        }
        if (data && data.code === "TOO_MANY_ATTEMPTS") {
          this.otpState = "locked";
          this.clearTimers();
          return;
        }

        this.attemptsRemaining =
          typeof data.attempts_remaining === "number"
            ? data.attempts_remaining
            : null;
        this.errorMessage =
          (data && data.message) || "Invalid verification code.";
        this.otpCode = "";
      } catch (error) {
        this.loading = false;
        this.errorMessage = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
      }
    },
    async onResend() {
      this.errorMessage = "";
      this.loading = true;
      try {
        const res = await forgotPasswordApi.resendOtp(this.sessionId);
        this.loading = false;
        const data = res.data;

        if (data && data.success) {
          this.otpCode = "";
          this.attemptsRemaining = null;
          this.otpState = "input";
          this.startOtpTimers();
          return;
        }

        if (data && data.code === "TOO_MANY_ATTEMPTS") {
          // ⭐ ยังไม่ครบ 10 นาที -> คง state locked ไว้ พร้อมข้อความเวลาที่เหลือ
          this.otpState = "locked";
          this.errorMessage =
            data.message || "Please wait before requesting a new code.";
          return;
        }

        this.errorMessage = (data && data.message) || "ส่ง OTP ใหม่ไม่สำเร็จ";
      } catch (error) {
        this.loading = false;
        this.errorMessage = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
      }
    },

    // ==================== STEP 3 ====================
    async onResetPassword() {
      this.errorMessage = "";
      if (!this.canSubmitPassword) return;

      this.loading = true;
      try {
        const res = await forgotPasswordApi.resetPassword(
          this.resetToken,
          this.newPassword,
          this.confirmPassword,
        );
        this.loading = false;

        if (res.data && res.data.success) {
          this.step = 4;
        } else {
          this.errorMessage =
            (res.data && res.data.message) || "รีเซ็ตรหัสผ่านไม่สำเร็จ";
          if (res.data && res.data.code === "RESET_TOKEN_INVALID") {
            // session/token หมดอายุระหว่างกรอก -> กลับไปเริ่มใหม่
            setTimeout(() => {
              this.step = 1;
            }, 2000);
          }
        }
      } catch (error) {
        this.loading = false;
        this.errorMessage = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
      }
    },
  },
};
